import { render, staticRenderFns } from "./borrowAndReturnDialog.vue?vue&type=template&id=0b25e5b0&scoped=true&"
import script from "./borrowAndReturnDialog.vue?vue&type=script&lang=js&"
export * from "./borrowAndReturnDialog.vue?vue&type=script&lang=js&"
import style0 from "./borrowAndReturnDialog.vue?vue&type=style&index=0&id=0b25e5b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b25e5b0",
  null
  
)

export default component.exports